import { render, staticRenderFns } from "./FFooter.vue?vue&type=template&id=59741740&scoped=true"
import script from "./FFooter.vue?vue&type=script&lang=js"
export * from "./FFooter.vue?vue&type=script&lang=js"
import style0 from "./FFooter.vue?vue&type=style&index=0&id=59741740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59741740",
  null
  
)

export default component.exports